module.exports = __webpack_public_path__ + "static/media/Nissi_Beach_Agia_Napa.4606362b.jpg";